import { sagaMiddleware, store } from '../../store';
import saga from './saga';
import * as cardActions from './actions';
import * as cardSelectors from './selectors';
import * as _persister from './persister';
import * as _reducers from './reducers';

export const actions = cardActions;
export const selectors = cardSelectors;
export const persister = _persister;

store.addReducers({
  card: _reducers.default
});

sagaMiddleware.run(saga);
